export const paramsTableColumns = [
  {
    key: 'required',
    dataIndex: 'required',
    span: 1
  },
  {
    title: '参数名',
    key: 'name',
    dataIndex: 'name',
    span: 5
  },
  {
    title: '参数值',
    key: 'value',
    dataIndex: 'value',
    span: 5
  },
  {
    title: '类型',
    key: 'type',
    dataIndex: 'type',
    span: 3
  },
  {
    title: '固定参数值',
    key: 'static',
    dataIndex: 'static',
    span: 3
  },
  {
    title: '说明',
    key: 'description',
    dataIndex: 'description',
    span: 5
  }
]

export const headersTableColumns = [
  {
    key: 'required',
    dataIndex: 'required',
    span: 1
  },
  {
    title: '参数名',
    key: 'name',
    dataIndex: 'name',
    span: 6
  },
  {
    title: '参数值',
    key: 'value',
    dataIndex: 'value',
    span: 6
  },
  {
    title: '类型',
    key: 'type',
    dataIndex: 'type',
    span: 4
  },
  {
    title: '说明',
    key: 'description',
    dataIndex: 'description',
    span: 6
  }
]

export const formdataTableColumns = [
  {
    key: 'required',
    dataIndex: 'required',
    span: 1
  },
  {
    title: '参数名',
    key: 'name',
    dataIndex: 'name',
    span: 6
  },
  {
    title: '参数值',
    key: 'value',
    dataIndex: 'value',
    span: 4
  },
  {
    title: '类型',
    key: 'type',
    dataIndex: 'type',
    span: 3
  },
  {
    title: 'Content-Type',
    key: 'contentType',
    dataIndex: 'contentType',
    span: 3
  },
  {
    title: '说明',
    key: 'description',
    dataIndex: 'description',
    span: 7
  }
]
